import {Constants} from "../../Constants/Constant";
import moment from "moment";
let cities = JSON.parse(localStorage.cities).map(c => c.city);

export function hotSettingsClientInvoices(colWidths = [], self, component='hotTableComponent'){
  let hotSettings = {
    data: null,
    readOnly: true,
    fillHandle: false,
    copyPaste: false,
    licenseKey: "non-commercial-and-evaluation",
    autoRowSize: false,
    autoColumnSize: false,
    colWidths: colWidths,
    className: "htCenter htMiddle",
    filters: true,
    dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
    columnSorting: { sortEmptyCells: true },
    afterChange: (changes, source) => {
      if(changes){
        changes.forEach(([row, prop, oldValue, newValue]) => {
          let hotInstance = self.$refs[component].hotInstance;
          let col = hotInstance.propToCol(prop);
          if(source === 'revert' || (newValue && parseInt(oldValue) === parseInt(newValue)) || self.columns[col].hasOwnProperty('component')) return;
          else if(!newValue) return hotInstance.setDataAtRowProp(row, prop, oldValue, 'revert');
          self.cellJSON = {row, prop, oldValue, newValue, hotInstance, title: self.columns[col].title.replace('<br> ',' ')};
          // console.log('oldValue', oldValue, 'newValue', newValue, source);
          self.cellUpdateDialog = true;
        });
      }
    },
  };
  return hotSettings
}

export const CellSettings = {
  [Constants.adminRoleId] : {
    'clientInvoices_billingFreight':{ isReadOnly: false },
  }
};

// export function totalChargesAmount(orderAmount = 0, pickupAmount = 0, dropAmount = 0, billingFreight = 0){
//   return (Number(orderAmount) + Number(pickupAmount) + Number(dropAmount) + Number(billingFreight));
// }
export function totalChargesAmount(invoice){
  let orderAmount = invoice.orderCharges.aggregate.sum.amount,
      pickupAmount = invoice.pickupCharges.aggregate.sum.amount,
      dropAmount = invoice.dropCharges.aggregate.sum.amount,
      billingFreight = invoice.billingFreight;
  return orderAmount + pickupAmount + dropAmount + billingFreight;
}

export function incrementClientInvoiceNumber(str){
  return str.replace(/\d+[^-]*$/, (match) => {
    let size = match.length;
    return ("0".repeat(size)+(++match)).substr(-size)
  })
}

export function isChargesEditable(roleId, invoiceStatus, city){
  if(roleId === Constants.adminRoleId) return true;
  return !!(roleId === Constants.cityManagerRoleId && cities.includes(city));
}

export function exportClientInvoicesCSV(columns, data, summary, fileName) {
  let re = /<\/?[^>]+(>|$)/g;                  //Remove html tags if any
  let str = summary + columns.filter(h => !h.excludeInExport).map(h => h.title.replace(re, "")).join(',') + '\n';
  let dataKeys = columns.filter(h => !h.excludeInExport).map(h => h.exportKey||h.data);
  data.forEach(d => {
    dataKeys.forEach(k => str = str + '\"' + (d[k]||(d[k]===0?0:'-')) + '\"' + ',');               //double quotes to avoid commas within string
    str = str + '\n'
  });

  let blob = new Blob([str], {type: 'text/plain'});
  const a = window.document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  // a.download = 'ClientInvoices_' + moment().format('DD_MMM_YYYY_HH_mm') + '.csv';
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
